
import scrollIntoView, { SmoothBehaviorOptions } from 'smooth-scroll-into-view-if-needed';
import dateformat from 'dateformat';
import megatron from '@stencil/megatron';
import { fetchHelper } from './../../utils/fetchHelper'
import format_dateObj from './../../utils/FormatDateObj';
import format_BusQueryDate from './../../utils/QueryDateFormat';
import getDateObj from './../../utils/GetDateObj';

export const scrollEletoView = (idOfElToScrollTo, options?: Partial<SmoothBehaviorOptions>) => {
  const elToScrollTo = document && document.querySelector(idOfElToScrollTo);
  if (!elToScrollTo) {
    return;
  }
  scrollIntoView(elToScrollTo, options);
}

export function prepareSRPURL(params) {
  let url = `/bus/search?bid=${prearebid(params)}`;
  if (params.routeId) {
    url += `&routeId=${params.routeId}`
  }
  return url;
}

export function prepareAlternateRouteURL(params) {
  let url = `/bus/alternateroutes/?bid=${prearebid(params)}`;
  if (params.routeId) {
    url += `&routeId=${params.routeId}`
  }
  return url;
}

export function preparePaymentsURL(params) {
  let url = `/bus/payments?bookingKey=${params.bookingKey}&routeId=${params.routeId}`;
  return url;
}

export function prearebid(params: {
  src_name: string; dest_name: string; src_vid: string | number; dest_vid: string | number; selectedDate: any
}) {
  const { src_name, dest_name, src_vid, dest_vid, selectedDate } = params;
  const date = dateformat(selectedDate, 'yyyymmdd');

  let bid = `bus-${src_name}-${dest_name}-${date}-0-0-0-0-${src_vid}-${dest_vid}`;
  return bid;
}

export function queryStringUrlReplacement(url, param, value) {
  var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;

  if (match === null) {
    // append new param
    var hasQuestionMark = /\?/.test(url);
    delimiter = hasQuestionMark ? "&" : "?";
    newString = url + delimiter + param + "=" + value;
  } else {
    delimiter = match[0].charAt(0);
    newString = url.replace(re, delimiter + param + "=" + value);
  }

  return newString;
}

export function replaceSRPUrlState({ history, search, keyName, inputValues }) {
  const { src_name, dest_name, src_vid, dest_vid, selectedDate } = inputValues;

  try {
    const bid = prearebid({
      src_name,
      dest_name,
      src_vid,
      dest_vid,
      selectedDate

    })
    const url = queryStringUrlReplacement(search, keyName, bid)

    history.replace(url);
  } catch (err) {
    console.warn(err);
  }
}


export var getQueryString = function (field, url) {
  var href = url ? url : window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? decodeURIComponent(string[1]) : null;
};

export function getNewPayments() {
  let count = 5;
  const success_loaded = () => {
    console.log('js loaded');
  };
  const error_loaded = (err, jsElm, callback) => {
    count--;
    jsElm.parentNode.removeChild(jsElm);
    if (count) {
      callback();
    }
  };
  function loadJS() {
    const jsElm = document.createElement('script');
    jsElm.type = 'application/javascript';
    jsElm.src = `${__ENV_CONFIG__.__GOIBIBO__}/mudra/dist/loadPayments.js?cb=${Math.random()}`;
    jsElm.onload = success_loaded;
    jsElm.onerror = () => {
      error_loaded('payments failed', jsElm, loadJS);
    };
    document.body.append(jsElm);
  }
  loadJS();
}

export function signIn() {
  document.querySelector('#get_sign_in').click();
}

export function signUp() {
  document.querySelector('#get_sign_up').click();
}

export function scrollToHead(id: string) {
  if (!id) {
    return;
  }
  const idOfElToScrollTo = `#${id}`;
  scrollEletoView(idOfElToScrollTo, {
    behavior: 'smooth',
    block: 'start',
  });
}

export function initAdConfig() {
  try {
    var initialConfig = {
      userCallbackForView: function (id) {
        console.log("view callback");
      },
      userClickHandlerForClick: function () {
        console.log("click callback");
      },
      onError: function () {
        console.log("On Error Callback");
      },
      ORG: "GI",
      AUTH_COOKIE_KEY: "OAUTH-GOIBIBO",
    };
    if (window) {
      if (window.AdMMTSDK) {
        window.AdMMTSDK.init(initialConfig);
      } else {
        window.AdMMTSDK = [];
        window.AdMMTSDK.push(initialConfig);
      }
    }
  } catch (err) {
    console.warn(err);
  }
}

export const pushDataToNewrelic = (queryStr) => {
  const url = `https://dexter.goibibo.com/common/newrelic/?serviceApp=superbus&${queryStr}`;

  megatron({
    name: 'newrelic custom param push',
    type: 'GET',
    url,
  })
}

export const callGoTribeAPI = async (slot) => {
  const url = `https://voyager.goibibo.com/api/v1/smart_engage/get_smart_ads/?context=gnr&flavour=v3&slots=%5B%22${slot}%22%5D&status=LIVE&lob=bus&vertical=bus`;
  return megatron({
    name: 'gotribe dweb',
    type: 'GET',
    url,
    credentials: 'include'
  })

}
export const pushDataToNewrelicFromServer = (queryStr) => {
  const url = `https://dexter.goibibo.com/common/newrelic/?serviceApp=superbus&${queryStr}`;
  fetchHelper({
    name: 'newrelic custom param push',
    type: 'GET',
    url: url,
  });
}

export const addRemoveArrayOperation = (arr: any[], val: any) => {
  const index = arr.indexOf(val);
  if (index === -1) {
    arr.push(val);
  } else {
    arr.splice(index, 1);
  }
  return arr;
}


export const fillSRPDataFromURL = (dispatch, fetchSrpDataThunk, search) => {
  let searchStr = decodeURIComponent(search);
  var bid = getQueryString('bid', searchStr);

  let src = getQueryString('src', searchStr);
  let dest = getQueryString('dest', searchStr);
  let src_id = getQueryString('src_id', searchStr);
  let dest_id = getQueryString('dest_id', searchStr);
  let onwDate = getQueryString('onwDate', searchStr);

  const queryParams = bid ? bid.split("-") : [];
  let dateFromQueryParams = queryParams[3] || onwDate;
  let doj = dateFromQueryParams;
  let searchDateObj = {}
  const currentDateObj = format_dateObj({ keyName: 'currentDate', value: dateformat(getDateObj(), 'yyyy-mm-dd') })

  if (dateFromQueryParams !== 'NA') {


    const queryDate = format_BusQueryDate(dateFromQueryParams);
    searchDateObj = format_dateObj({ keyName: 'searchDate', value: queryDate })
  }

  if (dateFromQueryParams === 'NA' || searchDateObj['searchDateRaw'].getTime() < currentDateObj['currentDateRaw'].getTime()) {
    doj = dateformat(currentDateObj['currentDateRaw'], 'yyyymmdd');
    searchDateObj = format_dateObj({ keyName: 'searchDate', value: format_BusQueryDate(doj) });
  }
  dispatch(fetchSrpDataThunk({

    src: queryParams[1] || src,
    dest: queryParams[2] || dest,
    src_id: queryParams[8] || src_id,
    dest_id: queryParams[9] || dest_id,
    doj: doj,
    src_name: queryParams[1] || src,
    dest_name: queryParams[2] || dest
  }));
}

export const getfooterRedisKey = () => {
  return "bus_dweb_funnel_footer_data";
}

export const isMobileView = () => {
  let width = 300;
  if (typeof document !== "undefined" && document && document.body && document.body.clientWidth) {
    width = document.body.clientWidth;
  }
  if (width > 768) {
    return false;
  }
  return true;
}

export const generateGUID = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  const guid = `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
  return guid;
};
 

export const saveSessionId =  () => {
  try {
    if(typeof window !== 'undefined') {
    const sessionId = generateGUID();
    sessionStorage.setItem('sessionId', sessionId);
    return sessionId;
    }
  } catch (error) {
    console.error("Error while saving session id", error);
    return null;
  }
};

export const getSessionID = () => {
  if (typeof window !== 'undefined') {
    const savedSessionId = sessionStorage.getItem('sessionId');
    if (savedSessionId == null) {
      return saveSessionId();
    } else {
      return savedSessionId;
    }
  }
};

export const textToChars = (text: string) =>
  text.split("").map((c) => c.charCodeAt(0));
 
const applySaltToChar = (salt: string) => (code: any) =>
  textToChars(salt).reduce((a, b) => a ^ b, code);
 
export const encrypt = (salt: string, text: string) => {
  const byteHex = (n: number) => ("0" + Number(n).toString(16)).substr(-2);
 
  return text
    .split("")
    .map(textToChars)
    .map(applySaltToChar(salt))
    .map(byteHex)
    .join("");
};
 

export const setSessionStorage = (key: string, value: any) => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(key, value);
  }
}
export const getSessionStorage = (key: string) => {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(key);
  }
}